var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 112,
    viewBox: "0 0 154 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3715 0L57.6287 23.6779C55.499 23.5526 53.9956 23.6779 52.2417 23.9284L54.3715 0Z",
    fill: "url(#paint0_linear_181476_183360)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3486 12.1514L49.9862 24.3035C48.7334 24.5541 47.7312 24.8046 46.6037 25.1804L44.3486 12.1514Z",
    fill: "url(#paint1_linear_181476_183360)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0718 5.5127L44.725 25.808C42.7205 26.4344 41.4677 27.3113 39.8391 28.1883L32.0718 5.5127Z",
    fill: "url(#paint2_linear_181476_183360)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.438 20.2959L38.3351 29.1907C37.3328 29.8171 36.4559 30.5688 35.5789 31.3205L28.438 20.2959Z",
    fill: "url(#paint3_linear_181476_183360)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6577 18.29L33.7002 32.6972C32.0716 34.0753 31.1946 35.3281 30.0671 36.7061L14.6577 18.29Z",
    fill: "url(#paint4_linear_181476_183360)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1611 34.0762L28.6891 38.5862C28.0627 39.5885 27.4363 40.5907 26.9352 41.593L16.1611 34.0762Z",
    fill: "url(#paint5_linear_181476_183360)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63086 38.9619L25.9329 44.2237C25.0559 46.1029 24.6801 47.6062 24.179 49.3601L2.63086 38.9619Z",
    fill: "url(#paint6_linear_181476_183360)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5234 52.4925L23.8031 51.4902C23.5525 52.743 23.5525 53.7453 23.4272 54.9981L10.5234 52.4925Z",
    fill: "url(#paint7_linear_181476_183360)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.638L23.4273 57.1279C23.302 59.2577 23.6778 60.761 23.9284 62.515L0 61.638Z",
    fill: "url(#paint8_linear_181476_183360)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2773 70.2814L24.3042 64.5186C24.5547 65.6461 24.8053 66.7736 25.3064 67.9011L12.2773 70.2814Z",
    fill: "url(#paint9_linear_181476_183360)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76465 84.1885L26.0577 70.1572C26.8094 72.0364 27.8116 73.2892 28.8139 74.7926L6.76465 84.1885Z",
    fill: "url(#paint10_linear_181476_183360)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5483 87.0695L30.1926 76.9219C30.9443 77.9241 31.5707 78.8011 32.4477 79.678L21.5483 87.0695Z",
    fill: "url(#paint11_linear_181476_183360)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2974 101.601L34.3264 81.5566C35.8298 83.06 37.0826 83.937 38.586 84.9392L21.2974 101.601Z",
    fill: "url(#paint12_linear_181476_183360)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.832 98.9719L40.4651 86.1934C41.4674 86.8198 42.4696 87.3209 43.5971 87.6967L36.832 98.9719Z",
    fill: "url(#paint13_linear_181476_183360)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0938 112L46.1027 88.4473C47.9819 89.1989 49.6105 89.4495 51.3644 89.8253L42.0938 112Z",
    fill: "url(#paint14_linear_181476_183360)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3735 103.105L53.6196 89.8252C54.8724 89.9505 55.9999 89.9505 57.1275 89.9505L55.3735 103.105Z",
    fill: "url(#paint15_linear_181476_183360)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3265 35.8299C45.8522 25.8075 63.2661 27.0603 73.2885 38.4608C73.5391 38.8366 73.7896 39.0872 74.1654 39.463C65.02 29.9418 49.8612 29.1901 39.8388 37.9597C29.4406 46.9798 28.3131 62.765 37.4585 73.2885C46.2281 83.3109 61.3869 84.689 71.6599 76.5458C71.4093 76.7964 71.0335 77.1722 70.6576 77.4228C59.1319 87.4451 41.718 86.1923 31.6956 74.7919C21.6733 63.2662 22.9261 45.8523 34.3265 35.8299Z",
    fill: "#1D1C1A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5395 76.4219C73.0384 77.0483 72.412 77.5494 71.7856 78.0505C60.2598 88.0729 42.9712 87.1959 32.4478 76.4219C32.6983 76.7977 33.0742 77.1736 33.45 77.5494C44.8504 90.7038 64.8952 92.0818 78.0495 80.5561C79.5529 79.3033 80.8057 77.8 82.0585 76.4219H73.5395Z",
    fill: "#C6C5C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5414 37.835C75.2931 38.5866 75.9195 39.4636 76.5459 40.3406H84.0627C83.1857 38.8372 82.1835 37.4591 80.9307 36.2063C69.5302 23.052 49.4855 21.6739 36.3311 33.1996C35.9553 33.5755 35.5795 33.826 35.2036 34.2018C47.2305 24.6806 64.519 26.184 74.5414 37.835Z",
    fill: "#D02027"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1422 61.28C50.214 60.7533 50.1622 60.3144 49.9867 59.9633C49.8112 59.6043 49.556 59.305 49.221 59.0657C48.886 58.8183 48.5112 58.6148 48.0964 58.4552C47.6817 58.2877 47.267 58.1321 46.8522 57.9884C46.254 57.781 45.6638 57.5376 45.0816 57.2583C44.5073 56.979 43.9889 56.6439 43.5263 56.2529C43.0637 55.8539 42.7008 55.3832 42.4376 54.8406C42.1824 54.298 42.0827 53.6636 42.1385 52.9375C42.2023 52.1315 42.4296 51.4254 42.8205 50.8189C43.2113 50.2045 43.7098 49.6938 44.3159 49.2869C44.9221 48.8799 45.5881 48.5767 46.3139 48.3772C47.0396 48.1777 47.7734 48.086 48.5152 48.1019C49.544 48.1259 50.4652 48.3573 51.2788 48.7961C52.0923 49.227 52.7264 49.8335 53.181 50.6155C53.6356 51.3974 53.835 52.3191 53.7792 53.3803L51.53 53.3684C51.5858 52.6741 51.4981 52.0797 51.2668 51.585C51.0355 51.0823 50.6766 50.6952 50.1901 50.4239C49.7115 50.1526 49.1213 50.009 48.4195 49.9931C47.7814 49.9771 47.1712 50.0729 46.589 50.2803C46.0148 50.4878 45.5282 50.811 45.1294 51.2498C44.7307 51.6807 44.4874 52.2353 44.3997 52.9135C44.3359 53.3843 44.3997 53.7873 44.5911 54.1224C44.7825 54.4575 45.0457 54.7408 45.3807 54.9722C45.7236 55.2036 46.0945 55.3991 46.4933 55.5587C46.9001 55.7183 47.2869 55.8579 47.6538 55.9776C48.2918 56.1931 48.906 56.4484 49.4962 56.7437C50.0944 57.0309 50.6208 57.382 51.0754 57.7969C51.538 58.2039 51.8889 58.6906 52.1282 59.2572C52.3755 59.8237 52.4672 60.49 52.4034 61.256C52.3316 62.0859 52.0963 62.804 51.6975 63.4105C51.2987 64.0169 50.7883 64.5156 50.1662 64.9066C49.544 65.2896 48.8621 65.5729 48.1204 65.7564C47.3786 65.9399 46.6329 66.0237 45.8832 66.0078C45.1015 65.9998 44.3598 65.8761 43.6579 65.6367C42.964 65.3894 42.3499 65.0383 41.8155 64.5834C41.2811 64.1286 40.8704 63.578 40.5832 62.9317C40.2961 62.2774 40.1725 61.5353 40.2124 60.7054L42.4496 60.7174C42.4097 61.276 42.4695 61.7667 42.629 62.1896C42.7886 62.6125 43.0278 62.9676 43.3469 63.2549C43.6739 63.5341 44.0607 63.7496 44.5073 63.9012C44.954 64.0448 45.4445 64.1206 45.9789 64.1286C46.609 64.1446 47.2231 64.0568 47.8213 63.8653C48.4274 63.6738 48.9419 63.3666 49.3646 62.9437C49.7873 62.5208 50.0465 61.9662 50.1422 61.28Z",
    fill: "#1D1C1A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5337 47.3838L56.3394 65.7684H54.162L57.3563 47.3838H59.5337ZM66.353 52.8178L59.9405 58.7545L56.0762 62.2375L56.3394 59.6761L58.9236 57.0429L63.5296 52.8178H66.353ZM62.1298 65.7684L58.6364 59.4726L60.0123 57.6174L64.4986 65.7684H62.1298Z",
    fill: "#1D1C1A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0019 64.2962L75.4574 52.8178H77.8501L70.2532 67.7792C70.0538 68.2021 69.8185 68.6091 69.5473 69C69.2841 69.391 68.981 69.7421 68.6381 70.0533C68.3031 70.3645 67.9242 70.6079 67.5015 70.7834C67.0788 70.959 66.6122 71.0468 66.1018 71.0468C65.8864 71.0388 65.6711 71.0148 65.4557 70.975C65.2324 70.9351 65.0171 70.8912 64.8097 70.8433L64.9413 69.024C65.037 69.0399 65.1327 69.0519 65.2284 69.0599C65.3241 69.0758 65.4159 69.0878 65.5036 69.0958C66.038 69.1118 66.4966 69.036 66.8794 68.8684C67.2702 68.7008 67.6052 68.4535 67.8844 68.1263C68.1715 67.7991 68.4267 67.4081 68.65 66.9533L70.0019 64.2962ZM69.4038 52.8178L70.9471 62.9915L71.0906 65.2776L69.4755 66.0676L67.1307 52.8178H69.4038Z",
    fill: "#1D1C1A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M108.501 61.28C108.573 60.7533 108.521 60.3144 108.346 59.9633C108.17 59.6043 107.915 59.305 107.58 59.0657C107.245 58.8183 106.87 58.6148 106.455 58.4552C106.041 58.2877 105.626 58.1321 105.211 57.9884C104.613 57.781 104.023 57.5376 103.44 57.2583C102.866 56.979 102.348 56.6439 101.885 56.2529C101.423 55.8539 101.06 55.3832 100.796 54.8406C100.541 54.298 100.442 53.6636 100.497 52.9375C100.561 52.1315 100.788 51.4254 101.179 50.8189C101.57 50.2045 102.069 49.6938 102.675 49.2869C103.281 48.8799 103.947 48.5767 104.673 48.3772C105.398 48.1777 106.132 48.086 106.874 48.1019C107.903 48.1259 108.824 48.3573 109.638 48.7961C110.451 49.227 111.085 49.8335 111.54 50.6155C111.994 51.3974 112.194 52.3191 112.138 53.3803L109.889 53.3684C109.945 52.6741 109.857 52.0797 109.626 51.585C109.394 51.0823 109.035 50.6952 108.549 50.4239C108.07 50.1526 107.48 50.009 106.778 49.9931C106.14 49.9771 105.53 50.0729 104.948 50.2803C104.374 50.4878 103.887 50.811 103.488 51.2498C103.09 51.6807 102.846 52.2353 102.759 52.9135C102.695 53.3843 102.759 53.7873 102.95 54.1224C103.141 54.4575 103.405 54.7408 103.74 54.9722C104.082 55.2036 104.453 55.3991 104.852 55.5587C105.259 55.7183 105.646 55.8579 106.013 55.9776C106.651 56.1931 107.265 56.4484 107.855 56.7437C108.453 57.0309 108.98 57.382 109.434 57.7969C109.897 58.2039 110.248 58.6906 110.487 59.2572C110.734 59.8237 110.826 60.49 110.762 61.256C110.69 62.0859 110.455 62.804 110.056 63.4105C109.658 64.0169 109.147 64.5156 108.525 64.9066C107.903 65.2896 107.221 65.5729 106.479 65.7564C105.737 65.9399 104.992 66.0237 104.242 66.0078C103.46 65.9998 102.719 65.8761 102.017 65.6367C101.323 65.3894 100.709 65.0383 100.174 64.5834C99.64 64.1286 99.2292 63.578 98.9421 62.9317C98.655 62.2774 98.5313 61.5353 98.5712 60.7054L100.808 60.7174C100.769 61.276 100.828 61.7667 100.988 62.1896C101.147 62.6125 101.387 62.9676 101.706 63.2549C102.033 63.5341 102.42 63.7496 102.866 63.9012C103.313 64.0448 103.803 64.1206 104.338 64.1286C104.968 64.1446 105.582 64.0568 106.18 63.8653C106.786 63.6738 107.301 63.3666 107.723 62.9437C108.146 62.5208 108.405 61.9662 108.501 61.28Z",
    fill: "#1D1C1A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.083 59.5085L113.119 59.2332C113.215 58.3635 113.43 57.5256 113.765 56.7197C114.108 55.9138 114.559 55.1956 115.117 54.5653C115.675 53.9349 116.337 53.4402 117.103 53.0811C117.869 52.722 118.722 52.5545 119.663 52.5784C120.572 52.5944 121.35 52.7898 121.996 53.1649C122.65 53.5399 123.177 54.0386 123.575 54.661C123.982 55.2754 124.265 55.9696 124.425 56.7437C124.584 57.5177 124.624 58.3156 124.544 59.1375L124.52 59.4128C124.417 60.2825 124.193 61.1164 123.85 61.9143C123.508 62.7123 123.053 63.4224 122.487 64.0448C121.928 64.6672 121.266 65.158 120.501 65.517C119.735 65.8681 118.886 66.0317 117.952 66.0078C117.051 65.9918 116.273 65.8003 115.619 65.4332C114.973 65.0582 114.451 64.5635 114.052 63.9491C113.653 63.3347 113.374 62.6444 113.215 61.8784C113.055 61.1124 113.011 60.3224 113.083 59.5085ZM115.273 59.2332L115.249 59.5205C115.193 60.0232 115.189 60.5458 115.237 61.0884C115.292 61.631 115.42 62.1337 115.619 62.5966C115.827 63.0594 116.126 63.4384 116.517 63.7336C116.908 64.0289 117.414 64.1845 118.036 64.2004C118.698 64.2164 119.28 64.0887 119.783 63.8174C120.285 63.5381 120.712 63.1631 121.063 62.6923C121.422 62.2215 121.705 61.6989 121.912 61.1244C122.128 60.5498 122.271 59.9793 122.343 59.4128L122.367 59.1375C122.423 58.6348 122.423 58.1121 122.367 57.5695C122.319 57.0189 122.192 56.5083 121.984 56.0375C121.785 55.5587 121.49 55.1717 121.099 54.8765C120.708 54.5732 120.202 54.4137 119.579 54.3977C118.917 54.3738 118.331 54.5054 117.821 54.7927C117.318 55.072 116.892 55.451 116.541 55.9298C116.19 56.4085 115.907 56.9391 115.691 57.5216C115.484 58.0962 115.344 58.6667 115.273 59.2332Z",
    fill: "#1D1C1A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.627 47.3838L128.433 65.7684H126.267L129.449 47.3838H131.627Z",
    fill: "#1D1C1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M139.702 63.5541L140.779 56.8633C140.835 56.3686 140.787 55.9337 140.636 55.5587C140.492 55.1837 140.249 54.8924 139.906 54.685C139.571 54.4775 139.148 54.3658 138.638 54.3498C138.191 54.3418 137.752 54.4137 137.322 54.5653C136.899 54.7169 136.532 54.9443 136.221 55.2475C135.91 55.5507 135.706 55.9337 135.611 56.3965L133.457 56.4085C133.513 55.7622 133.717 55.1996 134.067 54.7209C134.418 54.2341 134.857 53.8312 135.383 53.512C135.91 53.1848 136.476 52.9454 137.082 52.7938C137.688 52.6342 138.279 52.5584 138.853 52.5664C139.722 52.5824 140.476 52.7699 141.114 53.129C141.76 53.4801 142.247 53.9748 142.574 54.6131C142.901 55.2515 143.02 56.0175 142.933 56.9112L141.94 62.9437C141.868 63.3825 141.824 63.8254 141.808 64.2722C141.8 64.7111 141.852 65.142 141.963 65.5649L141.94 65.7684L139.75 65.7803C139.662 65.4133 139.619 65.0423 139.619 64.6672C139.627 64.2922 139.655 63.9211 139.702 63.5541ZM141.03 57.9166L140.779 59.4726L138.733 59.4606C138.303 59.4606 137.848 59.4926 137.369 59.5564C136.891 59.6202 136.436 59.7399 136.006 59.9155C135.575 60.091 135.212 60.3464 134.917 60.6815C134.622 61.0087 134.442 61.4356 134.379 61.9622C134.331 62.3931 134.383 62.7681 134.534 63.0873C134.694 63.3985 134.933 63.6419 135.252 63.8174C135.571 63.993 135.942 64.0847 136.364 64.0927C136.915 64.1007 137.457 63.993 137.992 63.7695C138.526 63.5461 138.993 63.2269 139.391 62.812C139.79 62.3971 140.065 61.9183 140.217 61.3757L141.006 62.441C140.855 62.9676 140.608 63.4543 140.265 63.9012C139.922 64.3401 139.515 64.7191 139.044 65.0383C138.582 65.3574 138.083 65.6048 137.549 65.7803C137.015 65.9559 136.48 66.0397 135.946 66.0317C135.22 66.0157 134.562 65.8522 133.972 65.541C133.39 65.2298 132.927 64.7949 132.584 64.2363C132.249 63.6698 132.105 63.0115 132.153 62.2614C132.201 61.4395 132.416 60.7493 132.799 60.1908C133.182 59.6322 133.673 59.1854 134.271 58.8502C134.877 58.5151 135.539 58.2757 136.257 58.1321C136.975 57.9805 137.684 57.9047 138.386 57.9047L141.03 57.9166Z",
    fill: "#1D1C1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M148.867 54.9483L146.988 65.7684H144.823L147.072 52.8178H149.178L148.867 54.9483ZM153.066 52.7101L152.862 54.7927C152.695 54.7608 152.523 54.7328 152.348 54.7089C152.18 54.685 152.013 54.673 151.845 54.673C151.327 54.665 150.86 54.7448 150.446 54.9124C150.039 55.072 149.676 55.2994 149.357 55.5946C149.046 55.8899 148.779 56.237 148.555 56.6359C148.34 57.0349 148.169 57.4658 148.041 57.9286L147.359 58.2877C147.447 57.6413 147.59 56.979 147.79 56.3008C147.997 55.6225 148.28 54.9962 148.639 54.4216C149.006 53.8471 149.465 53.3843 150.015 53.0332C150.573 52.6821 151.243 52.5185 152.025 52.5425C152.2 52.5425 152.372 52.5584 152.539 52.5904C152.715 52.6223 152.89 52.6622 153.066 52.7101Z",
    fill: "#1D1C1A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0375 48.3408L85.0523 55.0076L90.1488 48.3408H92.9125L86.1291 57.0783L90.1847 65.7679H87.6724L84.5738 58.9694L79.3456 65.7679H76.5581L83.497 56.8628L79.549 48.3408H82.0375Z",
    fill: "#C32723"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181476_183360",
    x1: 57.3167,
    y1: 1.06835,
    x2: 49.3162,
    y2: 22.8186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181476_183360",
    x1: 47.7948,
    y1: 13.0992,
    x2: 44.5377,
    y2: 24.5228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181476_183360",
    x1: 35.0973,
    y1: 5.34279,
    x2: 36.759,
    y2: 28.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_181476_183360",
    x1: 31.9572,
    y1: 19.8881,
    x2: 33.4573,
    y2: 31.6727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_181476_183360",
    x1: 17.4551,
    y1: 17.0271,
    x2: 27.2552,
    y2: 38.0335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_181476_183360",
    x1: 19.2875,
    y1: 32.2669,
    x2: 25.0969,
    y2: 42.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_181476_183360",
    x1: 4.65879,
    y1: 36.5473,
    x2: 22.2922,
    y2: 51.5916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_181476_183360",
    x1: 12.6492,
    y1: 49.6533,
    x2: 22.2319,
    y2: 56.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_181476_183360",
    x1: 0.904512,
    y1: 58.6933,
    x2: 23.0717,
    y2: 65.4672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_181476_183360",
    x1: 13.2042,
    y1: 66.8495,
    x2: 24.6597,
    y2: 69.9674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_181476_183360",
    x1: 6.31138,
    y1: 81.1367,
    x2: 29.2615,
    y2: 77.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_181476_183360",
    x1: 21.0257,
    y1: 83.4839,
    x2: 32.7618,
    y2: 81.6848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_181476_183360",
    x1: 19.7836,
    y1: 98.8893,
    x2: 40.0362,
    y2: 87.6221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_181476_183360",
    x1: 34.852,
    y1: 95.977,
    x2: 44.7691,
    y2: 89.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_181476_183360",
    x1: 39.6098,
    y1: 110.104,
    x2: 53.7048,
    y2: 91.7108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_181476_183360",
    x1: 52.3157,
    y1: 101.175,
    x2: 58.8193,
    y2: 91.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.76013f711a0c302dc1dfd897fbcdc6fe.svg";
export { ForwardRef as ReactComponent };